/**
 * Service worker registration helper (KNOWN_ISSUES §1.43).
 *
 * Loads `/service-worker.js` after the page is interactive so SW
 * install never delays first paint. Skipped:
 *   • In dev (`process.env.NODE_ENV !== "production"`) — the CRA dev
 *     server serves uncached bundles + the SW would fight HMR.
 *   • When the browser doesn't expose `navigator.serviceWorker` (old
 *     mobile Safari, in-app browsers, etc.) — fail-soft to no-PWA.
 *   • When `REACT_APP_DISABLE_SW=true` — emergency kill switch for ops.
 *
 * On a successful registration: emits one `console.info` so the team
 * can confirm install via DevTools without leaning on the Sentry-
 * SDK's noisy `console.log` spam.
 */
export function register() {
  if (process.env.NODE_ENV !== "production") return;
  if ((process.env.REACT_APP_DISABLE_SW || "").toLowerCase() === "true") return;
  if (!("serviceWorker" in navigator)) return;

  // Defer until window load so SW work doesn't compete with first
  // paint on slow devices.
  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;
    navigator.serviceWorker.register(swUrl)
      .then((reg) => {
        // eslint-disable-next-line no-console
        console.info("[pwa] service worker registered", { scope: reg.scope });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[pwa] service worker registration failed", err);
      });
  });
}


export function unregister() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready.then((reg) => reg.unregister()).catch(() => {});
}
